<!-- 角色管理 -->
<template>
  <div class="diseaseList">
    <el-button class="addBtn" type="primary" size="small" v-waves @click="handleAdd">新增</el-button>
    <div class="tableList">
      <ElTable :columns="listHeader" :tableData="tableData" :loading="loading" :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
        <!-- <template slot="parent_id" slot-scope="{ row }">
          <p v-if="!row.parent_id">
            —
          </p>
          <el-tag effect="dark" size="mini" v-else>
            所属上级{{ row.parent_id }}
          </el-tag>
        </template>
<template slot="store_id" slot-scope="{ row }">
          <p v-if="!row.store_id">
            —
          </p>
          <el-tag type="success" effect="dark" size="mini" v-else>
            <StoreToString :store_id="row.store_id" />
          </el-tag>
        </template> -->
        <template slot="status" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.status == 1">
            启用
          </el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else> 禁用 </el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <!-- <el-button size="mini" type="text" @click="handleRole(row)" primary>设置权限</el-button> -->
            <el-button class="editBtn" size="mini" type="text" @click="handleEdit(row)" primary>编辑</el-button>
            <el-button size="mini" type="text" style="color: rgb(255, 0, 0)" :disabled="row.id == 1"
              @click="handleDelete(row)">删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
    <!-- 表单弹窗 -->
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" v-if="dialogVisible">
      <el-form ref="form" :model="dialogForm" label-width="90px">
        <el-form-item label="状态:" required>
          <el-select v-model="dialogForm.status" placeholder="请选择" style="width: 100%" clearable
            :disabled="dialogForm.id == 1">
            <div v-for="(item, index) in gradeList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="角色名称" required>
          <el-input clearable v-model="dialogForm.title"></el-input>
        </el-form-item>
        <el-form-item label="导航权限" required> </el-form-item>
        <div style="height: 300px; overflow-y: auto; margin: 0 auto; width: 80%">
          <el-tree ref="tree" :data="navData" show-checkbox node-key="id" :default-expanded-keys="defaultExpandedKeys"
            :default-checked-keys="checkedData" :props="defaultProps" :check-strictly="true">
          </el-tree>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="handleClose">取 消</el-button>
        <el-button class="addBtn" size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import { mapState } from "vuex";
import {
  selectAdmin,
  deleteAdmin,
  updateAdmin,
  addAdmin,
} from "@/services/system/authGroup";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab,
    StoreToString,
  },
  // directives: {
  //   waves,
  // },
  created() {
    //根据权限初始化导航
    this.navData = this.$store.state.navList;
    this.getListData();
    // this.getStoreData();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
      storeList: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      gradeList: [
        { id: 1, name: "启用" },
        { id: 2, name: "禁用" },
      ],
      roleVisible: false,
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      defaultExpandedKeys: [], //默认展开项
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo"]),
  },

  watch: {},
  methods: {
    async getListData() {
      this.loading = true;
      this.listQuery.createID = this.userInfo.id;
      const { data, code, count } = await selectAdmin(this.listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建角色";
      this.dialogForm = {};
      this.checkedData = [];
      this.defaultExpandedKeys = this.navData.map((item) => item.id); //默认全部展开
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "编辑角色";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.checkedData = this.dialogForm.rules?.split(",");
      this.defaultExpandedKeys = this.navData.map((item) => item.id); //默认全部展开
    },
    /* 关闭弹窗 */
    handleClose() {
      this.$refs.tree.setCheckedKeys([]);
      this.dialogVisible = false;
    },
    /* 设置权限 */
    handleRole(row) {
      this.roleVisible = true;
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.checkedData = this.dialogForm.rules?.split(",");
    },

    /* 权限保存 */
    roleSave() {
      // console.log(this.$refs.tree.getCheckedNodes());
      // console.log(this.$refs.tree.getCheckedKeys());
      // console.log(this.$refs.tree.getHalfCheckedKeys())
      // console.log(this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys()));
    },

    save() {
      const rules = this.$refs.tree.getCheckedKeys().join(",");
      console.log(this.dialogForm, rules);

      if (!this.dialogForm.title || !this.dialogForm.status || !rules) {
        this.$message.error("请填写必填字段");
        return;
      }
      if (this.dialogName === "创建角色") {
        addAdmin({
          ...this.dialogForm,
          rules,
          createID: this.userInfo.id,
        }).then((res) => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.$message({
              type: "success",
              message: "创建成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
      if (this.dialogName === "编辑角色") {
        updateAdmin({
          ...this.dialogForm,
          rules,
        }).then((res) => {

          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAdmin({ id: row.id }).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getListData();
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
